/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App wird vom Service Worker aus dem Cache bereitgestellt.\n' +
        'Weitere Informationen: https://goo.gl/AFskqB'
      );
    },
    registered() {
      console.log('Service Worker wurde registriert.');
    },
    cached() {
      console.log('Inhalte wurden für Offline-Nutzung zwischengespeichert.');
    },
    updatefound() {
      console.log('Neue Inhalte werden heruntergeladen.');
    },
    updated() {
      console.log('Neue Inhalte sind verfügbar; bitte aktualisieren.');
      // Optional: Benutzer zum Neuladen auffordern
      if (confirm('Neue Version verfügbar! Seite neu laden?')) {
        window.location.reload();
      }
    },
    offline() {
      console.log('Keine Internetverbindung gefunden. App läuft im Offline-Modus.');
    },
    error(error) {
      console.error('Fehler während der Service-Worker-Registrierung:', error);
    }
  });
}